import { api } from '../client'
import type { RequestOptions } from '../client'
import type { AiHistoryEntry, AiHistoryFilters } from './types'

function buildQuery(f: AiHistoryFilters): string {
  const params = new URLSearchParams()
  if (f.limit !== undefined) params.set('limit', String(f.limit))
  if (f.offset !== undefined) params.set('offset', String(f.offset))
  if (f.search) params.set('search', f.search)
  if (f.sort) params.set('sort', f.sort)
  if (f.order) params.set('order', f.order)
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

export const aiHistoryHttpApi = {
  list: (filters: AiHistoryFilters = {}, options?: RequestOptions): Promise<AiHistoryEntry[]> =>
    api.get<AiHistoryEntry[]>(`/ai-history${buildQuery(filters)}`, options),
  count: (
    filters: Pick<AiHistoryFilters, 'search'> = {},
    options?: RequestOptions,
  ): Promise<number> =>
    api
      .get<{ count: number }>(`/ai-history/count${buildQuery(filters)}`, options)
      .then((r) => r.count),
}
